import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "form-check" }
const _hoisted_4 = ["onUpdate:modelValue", "value", "id"]
const _hoisted_5 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.modal?.title,
    modelValue: _ctx.modal !== null,
    "footer-class": "border-top-0 d-flex justify-content-between",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                "onUpdate:modelValue": ($event: any) => ((_ctx.form.result) = $event),
                value: result,
                type: "radio",
                name: "reason",
                id: `result_${result}`
              }, null, 8, _hoisted_4), [
                [_vModelRadio, _ctx.form.result]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `result_${result}`
              }, _toDisplayString(_ctx.helper.trans(`dispute_result.${result}`)), 9, _hoisted_5)
            ]))
          }), 256))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.modal?.cancelTitle ?? _ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.modal?.okTitle ?? _ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}